import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import Logo from './Logo';

export default function Header({ scrollToSection }) {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const handleNavClick = (id) => {
        scrollToSection(id);
        setMobileMenuOpen(false);
    };

    const navItems = [
        { id: 'servicos', label: 'Serviços' },
        { id: 'processo', label: 'Processo' },
        { id: 'faq', label: 'FAQ' },
        { id: 'contato', label: 'Contato' },
    ];

    return (
        <header className="sticky top-0 z-50 bg-black text-white shadow-lg">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-16">
                    <div className="flex items-center gap-3">
                        <Logo />
                        <span className="text-2xl font-bold text-cyan-400">Roldan Eng. Software</span>
                    </div>

                    {/* Desktop Menu */}
                    <nav className="hidden md:flex gap-8">
                        {navItems.map((item) => (
                            <button
                                key={item.id}
                                onClick={() => handleNavClick(item.id)}
                                className="hover:text-cyan-400 transition"
                            >
                                {item.label}
                            </button>
                        ))}
                    </nav>

                    {/* Mobile Menu Button */}
                    <button className="md:hidden" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
                        {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
                    </button>
                </div>

                {/* Mobile Menu */}
                {mobileMenuOpen && (
                    <nav className="md:hidden pb-4 flex flex-col gap-3">
                        {navItems.map((item) => (
                            <button
                                key={item.id}
                                onClick={() => handleNavClick(item.id)}
                                className="text-left hover:text-cyan-400"
                            >
                                {item.label}
                            </button>
                        ))}
                    </nav>
                )}
            </div>
        </header>
    );
}
